import styled from 'styled-components';

export const Wrapper = styled.div`
  .temporary-announcement {
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background-color: #fefcbf;
    color: #744210;
    width: 100%;
    padding: 1rem 1.5rem;
    display: flex;
    align-items: center;
    flex-direction: row;

    .temporary-announcement-message {
      color: #744210;
      line-height: 21px;
      flex: 1;
    }

    .temporary-announcement-wrapper {
      flex: 1;
      display: flex;
      gap: 1rem;
      align-items: center;
      justify-content: space-between;
      height: fit-content;

      @media (max-width: 1030px) {
        flex-direction: column;
        align-items: flex-start;
      }
    }

    h3 {
      color: #2d3748;
      font-weight: bold;
      font-size: 0.875rem;
      line-height: 1.5rem;
    }

    p {
      color: #232b33;
      font-weight: normal;
      font-size: 1rem;
      line-height: 1.5rem;
      padding-bottom: 0.5rem;
    }

    .temporary-announcement-close-button {
      background-color: transparent;
      background: transparent;
      border: 0;
      outline: none;
      box-shadow: none;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      padding: 0;
      height: 30px;
      width: 40px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #744210;

      &:focus,
      &:focus-visible,
      &:active {
        outline: none;
        box-shadow: none;
        border-color: transparent;
      }
      @media (max-width: 1030px) {
        align-self: flex-start;
        padding: 0 0.5rem;
      }
    }

    .temporary-announcement-cta {
      border-radius: 0.6rem;
      cursor: pointer;
      border: none;
      outline: none;
      height: 40px;
      font-size: 0.875rem;
      background-color: transparent;
      color: #5f370e;
      border: 1px solid #5f370e;
      padding: 0 12px;
      &,
      span {
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 600;
      }
      :focus {
        outline: none;
      }
    }

    .temporary-announcement-icon {
      margin: 0rem 1rem 0 0;
    }

    @media (max-width: 1030px) {
      align-items: flex-start;
      h3 {
        font-size: 0.875rem;
        br {
          display: none;
        }
      }
      p {
        font-size: 0.875rem;
      }
      .temporary-announcement-icon {
        margin: 0.5rem 0.75rem 0 0;
      }
      .temporary-announcement-cta {
        border-radius: 0.75rem;
      }
    }
  }

  .dev-banner-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    background-color: #007bff;
    color: white;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 12px;
    border: none;
    outline: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #0056b3;
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }
  }
`;
